import { useQuery } from 'react-query'
import { getWorkerDetails } from '../../../services/getWorkerDetails'

export const useGetWorkerProfile = (workerId, bookingId) => {
    return useQuery('getWorkerDetails', () => getWorkerDetails(workerId, bookingId))
}
